/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * VNU: liên kết mở ra khi bấm vào một phần tử của chart. Ba nơi cấu hình được,
 * nơi sau làm mặc định cho nơi trước:
 *
 * 1. Trên dashboard: Sửa dashboard → menu ⋮ của chart → "Liên kết khi bấm".
 *    Ghi vào layout: `meta.vnuClickUrl`.
 * 2. Trên chart: thêm `"vnu_click_url": "..."` vào params của chart.
 * 3. Trên dashboard, Sửa thuộc tính → JSON metadata:
 *      "vnu_chart_links": { "<id chart>": "...", "<uuid chart>": "..." }
 *
 * Cú pháp URL xem `plugins/plugin-chart-echarts/src/utils/vnuClickLink.ts`.
 */
export const VNU_CLICK_URL_KEY = 'vnu_click_url';
export const VNU_CHART_LINKS_KEY = 'vnu_chart_links';

export default function getVnuChartLink({
  layoutComponent,
  formData,
  metadata,
  sliceId,
}) {
  const fromLayout = layoutComponent?.meta?.vnuClickUrl;
  if (fromLayout) return fromLayout;

  const fromChart = formData?.[VNU_CLICK_URL_KEY];
  if (fromChart) return fromChart;

  const links = metadata?.[VNU_CHART_LINKS_KEY];
  if (!links) return undefined;
  const uuid = layoutComponent?.meta?.uuid;
  return links[String(sliceId)] ?? (uuid ? links[uuid] : undefined);
}
